import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'

export const EducationLevelRoutes = [
  {
    path: '/education-levels',
    name: 'ListEducationLevels',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'education_level:list'
    }
  },
  {
    path: '/education-level',
    name: 'CreateEducationLevel',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'education_level:create'
    }
  },
  {
    path: '/education-level/:id',
    name: 'UpdateEducationLevel',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'education_level:update'
    }
  }
]
